var directive = function($rootScope) {
  return {
    templateUrl: require('../templates/loader.html')
  };
};

directive.$inject = ['$rootScope'];

tiz.directive("loader", directive);
